<div class="g-hero" *ngIf="main.activeItem && activeExtension && activeWidget">
    <div class="g-hero-text">
        <div class="g-hero-text-detail">
            <div class="g-icon-text-horizontal">
                <div class="icon"><app-icon [name]="main.activeItem.iconInfo.toLowerCase()"></app-icon></div>
                <div class="text">
                    <h4 class="name">{{main.activeItem.name | slice:0:33}}</h4>
                    <div class="call-sign">{{main.activeItem.gmsId}}</div>
                </div>
            </div>
            <div class="g-hero-text-headline---">
                <div class="text">
                    <img class="ext-logo" [src]="extensionsService.getImageUrl(activeWidget.logo || activeExtension.logo)">
                    <h4 class="widget-title">{{activeWidget.widget}}</h4>

                    <div class="datepicker-box" *ngIf="gmsId">
                        <mat-form-field appearance="fill" class="slide-toggle-text">
                            <mat-label>Enter a date range</mat-label>
                            <mat-date-range-input [rangePicker]="picker" [formGroup]="chartDateRange" [min]="chartDateMin" [max]="chartDataMax">
                                <input matStartDate #dateRangeStart placeholder="Start date" formControlName="start">
                                <input matEndDate #dateRangeEnd placeholder="End date" formControlName="end" (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)">
                            </mat-date-range-input>
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-date-range-picker #picker></mat-date-range-picker>

                            <mat-error *ngIf="chartDateRange.controls.start.hasError('matStartDateInvalid')">Invalid start date</mat-error>
                            <mat-error *ngIf="chartDateRange.controls.end.hasError('matEndDateInvalid')">Invalid end date</mat-error>
                        </mat-form-field>
                        <div class="date-ranges">
                            <span class="datepicker-button" (click)="last24Hours()">last<br>24 hours</span>
                            <span class="datepicker-button" (click)="lastWeek()">last<br>week</span>
                            <span class="datepicker-button" (click)="lastMonth()">last<br>month</span>
                        </div>
                        <div class="data-toggle form-field slide-toggle-text" [style.visibility]="activeWidget?.referenceX ? 'visible' : 'hidden'">
                            <mat-slide-toggle (click)="toggleChartType()" [checked]="rpmMode">
                              {{activeWidget?.referenceXText}}
                            </mat-slide-toggle>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="g-hero-img">
        <mat-spinner *ngIf="showSpinner"></mat-spinner>
        <app-highchart *ngIf="chart && gmsId" [options]="chart" [oneToOne]="true" [(update)]="updateFlag"></app-highchart>
    </div>
</div>
